import React, { useState } from "react";
import styles from "./SupervisorRecipeDetails.module.css";
import StepsComponent from "../../../../../../components/StepsComponent/StepsComponent";
import SubmitButton from "../../../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../../../components/textComponent/TextComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "antd";

const RecipeComponent = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const steps = ["Mixing", "Make Up", "Proofing",];
  const [selectedBtn, setselectedBtn] = useState("btn1");

  const current = Number(new URLSearchParams(search).get("step")) || 0;
  const onNext = () => {
    if (current < steps.length - 1) {
      navigate(`?step=${current + 1}`);
    }
  };

  const onPrev = () => {
    if (current > 0) {
      navigate(`?step=${current - 1}`);
    }
  };

  const basicInfoData = {
    "Process Name": "Apprentice",
    "Process Time": "2:30 Mins",
  };
  const methodData = {
    "Machine Used": "Brick Oven",
    Parameters: "",
    Time: "2:30 Mins",
    Temperature: "25°C",
  };
  const additionalData = {
    Time: "2:30 Mins",
  };
  const instructionsData = {
    "01": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "02": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "03": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "04": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "05": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "06": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "07": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "08": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "09": "prep Cambro with canola oil, 11.3Kg max dough per container",
  };

  const finishedDataColumns = [
    {
      title: "",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
  ];

  const finishedData = [
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
      value: "45",
    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
      value: "20",
    },

    // "Bake Temperature (Fahrenheit)": "45",
    // "Time (minutes)": "20",
  ];

  return (
    <>
      <div className={styles.stepsComp}>
        <StepsComponent
          steps={steps}
          currentStepIndex={current}
          onPrev={onPrev}
          onNext={onNext}
        />
      </div>
      <div className={styles.mainCont}>
        <div className={styles.buttonsDiv}>
           {/* {current == 0 ? (
          <TextComponent className={styles.Heading} text={"Standard Proof (PROOF-SD-2HR)"} />
             ) : current == 1 ? (
          <TextComponent className={styles.Heading} text={"Standard Proof (PROOF-SD-2HR)"} />
          ): */}
           {current == 0 ? (
          <TextComponent className={styles.Heading} text={"Sourdough Dough Mix (MIX-SD-BASE)"} />
        ) : current == 1 ? (
           <TextComponent className={styles.Heading} text={"Batard Make Up"} />
        ) : current == 2 ? (
          <TextComponent className={styles.Heading} text={"Standard Proof (PROOF-SD-2HR)"} />
        ) : null}
          <SubmitButton
            title={"Stage 1"}
            primary={selectedBtn === "btn1" ? true : false}
            onClick={() => setselectedBtn("btn1")}
            btnContainerClass={styles.stageBtn}
            btnClass={styles.btn}
            textClass={styles.finishedBtnTxt}
          />
          <SubmitButton
            title={"Stage 2"}
            primary={selectedBtn === "btn3" ? true : false}
            onClick={() => setselectedBtn("btn3")}
            btnContainerClass={styles.stageBtn}
            btnClass={styles.btn}
            textClass={styles.finishedBtnTxt}
          />

          <SubmitButton
            title={"Finished Process Parameters"}
            primary={selectedBtn === "btn2" ? true : false}
            onClick={() => setselectedBtn("btn2")}
            btnContainerClass={styles.finishedBtn}
            btnClass={styles.btn}
            textClass={styles.finishedBtnTxt}
          />
        </div>
        <div className={styles.parentCont}>
          {selectedBtn === "btn1" && (
            <>
              <div className={styles.leftCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Basic Information"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(basicInfoData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent className={styles.Heading} text={"Method"} />
                  <div className={styles.itemsList}>
                    {Object.entries(methodData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Additional Parameter"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(additionalData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className={styles.rightCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Instructions"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(instructionsData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.inLineRow}>
                          <TextComponent
                            className={styles.instructionslabel}
                            text={`${formattedLabel} `}
                          />
                          <TextComponent
                            className={styles.instructionsvalue}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.parentCont}>
          {selectedBtn === "btn3" && (
            <>
              <div className={styles.leftCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Basic Information"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(basicInfoData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent className={styles.Heading} text={"Method"} />
                  <div className={styles.itemsList}>
                    {Object.entries(methodData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Additional Parameter"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(additionalData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className={styles.rightCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Instructions"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(instructionsData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.inLineRow}>
                          <TextComponent
                            className={styles.instructionslabel}
                            text={`${formattedLabel} `}
                          />
                          <TextComponent
                            className={styles.instructionsvalue}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {selectedBtn === "btn2" && (
          <>
            <div className={styles.box}>

              <div className={styles.TableDiv}>
                <Table
                  scroll={{ x: true }}
                  columns={finishedDataColumns}
                  dataSource={finishedData}
                  pagination={false}
                  rowKey="parameters"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default RecipeComponent;
